export class DateFormater
{
  static readonly DEFAULT_FORMAT = "{year}-{month}-{day} {hours24}:{minutes}:{seconds}";
  static readonly DEFAULT_FORMAT_REVERSE = "{hours24}:{minutes}:{seconds} {day}-{month}-{year}";
  private static _leadingZero( value:number, numDigits:number = 2 ):string
  {
    
    let stringValue = value + "";

    while ( stringValue.length < numDigits )
    {
      stringValue = "0" + stringValue;
    }

    return stringValue;
  }


  static now( format:string = DateFormater.DEFAULT_FORMAT )
  {
    return DateFormater.format( new Date(), format );
  }

  static format( date:Date, format:string = DateFormater.DEFAULT_FORMAT )
  {
    let year  = date.getFullYear() + "";
    let month = this._leadingZero( date.getMonth() + 1 );
    let day   = this._leadingZero( date.getDate() );

    let minutes = this._leadingZero( date.getMinutes() );
    let hours = date.getHours();
    let hours24 = this._leadingZero( hours );
    let hours12 = this._leadingZero( hours % 12 );
    if ( hours12 === "00" ){ hours12 = "12"; }
    let period = hours < 12 ? "a" : "p";

    let seconds = this._leadingZero( date.getSeconds() );
     

    format = format.replace( /{year}/ig, year );
    format = format.replace( /{month}/ig, month );
    format = format.replace( /{day}/ig, day );
    format = format.replace( /{hours24}/ig, hours24 );
    format = format.replace( /{hours12}/ig, hours12 );
    format = format.replace( /{period}/ig, period );
    format = format.replace( /{minutes}/ig, minutes );
    format = format.replace( /{seconds}/ig, seconds );

    return format;
  }
}